import React, { Component } from 'react';

class TableCell extends Component {
    constructor(props) {
        super(props);

        this.state = {
            disabled: this.props.disabled,
            width: this.props.width,
            color: this.props.color,
            background: (this.props.background) ? this.props.background : '',
            maxWidth: this.props.maxWidth,
            overflow: this.props.maxWidth ? 'hidden':'',
            textAlign:this.props.textAlign
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.color !== this.state.color) {
            this.setState({
                color: nextProps.color
            });
        }
    }

    render() {
        const { disabled, width, color, background, maxWidth , overflow , textAlign} = this.state;

        let td;

        var hideOn = this.props.hideOn ? this.props.hideOn : '';

        if (disabled) {
            if (width)
                td = (<td className={hideOn} style={{ width: width, color: color, background: background, maxWidth: maxWidth, overflow: overflow, textAlign: textAlign }}>{this.props.children}</td>);
            else
                td = (<td className={hideOn} style={{ color: color, background: background, maxWidth: maxWidth, overflow: overflow, textAlign: textAlign }}>{this.props.children}</td>);
        } else {
            if (width)
                td = (<td className={hideOn} style={{ width: width, color: color, background: background, maxWidth: maxWidth, overflow: overflow, textAlign: textAlign }} onClick={this.props.handleClick}>{this.props.children}</td>);
            else
                td = (<td className={hideOn} style={{ color: color, background: background, maxWidth: maxWidth , overflow: overflow, textAlign: textAlign}} onClick={this.props.handleClick}>{this.props.children}</td>);
        }

        return td;
    }
}

export default TableCell;


// WEBPACK FOOTER //
// ./src/views/Plugins/Table/table-cell.js